<div class="flex items-center pl-4 space-x-3" *ngIf="content.isPublished()">
  <a
    class="italic underline text-project-4300 hover:cursor-pointer hover:brightness-110 active:brightness-95"
    *ngIf="content.isPublished() && content.dynamicData.currentDraftVersion"
    [routerLink]="[
      '/content',
      CONTENT_TYPE_ROUTER_PATH[contentType],
      content.contentId,
      'edit'
    ]"
    data-testid="unpublished-draft"
  >
    There is an unpublished draft of this article: would you like to view it
    instead?
  </a>
  <a
    class="italic underline text-project-4300 hover:cursor-pointer hover:brightness-110 active:brightness-95"
    *ngIf="
      content.isPublished() &&
      !content.isCurrentLiveVersion() &&
      !content.dynamicData.currentDraftVersion
    "
    [routerLink]="[
      '/content',
      CONTENT_TYPE_ROUTER_PATH[contentType],
      content.contentId,
      'edit'
    ]"
    data-testid="old-version"
  >
    You are not looking at the latest version of this article, click here to
    view it instead
  </a>
</div>
